export default __webpack_public_path__ + "static/media/Bitcoin _Outline.1f348c44.svg";